<template>
  <GestionReporteAcumuladoUsuario />
</template>
<script>
import GestionReporteAcumuladoUsuario from "./components/GestionReporteAcumuladoUsuario";
export default {
  components: { GestionReporteAcumuladoUsuario },
};
</script>